import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import accountReducer from "./slice/accountSlide";
import userReducer from "./slice/userSlice";
import postReducer from "./slice/postSlice";
import topicReducer from "./slice/topicSlide";
import categoryReducer from "./slice/categorySlice";
import roleReducer from "./slice/roleSlide";
import permissionReducer from "./slice/permissionSlide";
import podcastReducer from "./slice/podcastSlice";
import uploadReducer from "./slice/uploadSlice";

export const store = configureStore({
  reducer: {
    account: accountReducer,
    user: userReducer,
    post: postReducer,
    topic: topicReducer,
    category: categoryReducer,
    role: roleReducer,
    permission: permissionReducer,
    podcast: podcastReducer,
    upload: uploadReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
